import { TapiConfig } from './base';

export const getTestingEnvConfig: (base: TapiConfig) => TapiConfig = (
  base
) => ({
  ...base,
  requests: {
    healthStatus: {
      pollingInterval: 30000,
    },
    ...base.requests,
  },
});
